export enum UserRole {
  SUPER_ADMIN = 'superadmin',
  CLIENT_ADMIN = 'clientadmin',
  CLIENT = 'client'
}